// extracted by mini-css-extract-plugin
export default {"container":"FileInput_container__thLqA","error":"FileInput_error__tYhcz","dz":"FileInput_dz__WEodT"};